<template>
  <div class="document">
    <!-- 查询条件 -->
    <div class="search">
      <ul class="search_ul">
        <li 
          class="search_li" 
          :class="{'search_li_active': productionId === item._id}" 
          v-for="item in productList" 
          :key="item._id"
          @click="handleClick(item._id)"
        >
          <span>{{ item.name }}</span>
          <i></i>
        </li>
      </ul>
    </div>
    <!-- tabs切换 -->
    <div class="wapper">
      <div class="tabs">
        <div class="tabs-nav">
          <div 
            class="tab" 
            v-for="item in tabsList" 
            :key="item.name" 
            :class="{ 'active': $route.name === item.name }"
          >
            <router-link :to="item.name" replace>{{ item.label }}</router-link>
          </div>
        </div>
        
        <div class="tabs-content" v-if="childChange">
          <transition name="slide-left">
            <keep-alive>
              <router-view></router-view>
            </keep-alive>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapActions, mapMutations ,mapState } from 'vuex';
  export default {
    name:'Document',
    data() {
      return {
        productList:[],//产品列表
        productionId:'',//产品id
        tabsList:[
          {
            name:'CommonQuestion',
            label:'常见问题'
          },{
            name:'QuestionType',
            label:'问题分类'
          },{
            name:'NewUser',
            label:'新手入门'
          }
        ],//tabs列表
        childChange: true
      };
    },
    computed: {
      ...mapState({
        currentClient: state=>state.User.currentClient,
      })
    },
    created() {
      // 获取产品列表
      this.getProductionClientInfo();
    },
    components: {},
    methods: {
      ...mapActions(['productionClientInfo']),
      ...mapMutations(['setProductionId']),
      // 产品列表点击事件
      handleClick(id){
        this.productionId = id;
        this.setProductionId(id);
        // 重置子组件,防止页面切换时缓存的子组件均调接口
        this.childChange = false;
        this.$nextTick(() => {
          this.childChange = true;
        });
      },
      // 获取产品列表
      getProductionClientInfo(){
        this.productionClientInfo({
          "category": this.currentClient,   //产品端  B端:"2B" C端:"2C"
        }).then(list => {
          this.productList = list;
          const { id } = this.$route.query;
          this.productionId = id ? id : (list && list.length > 0 ? list[0]._id : null);
          this.setProductionId(this.productionId);
        })
      }
    }
  };
</script>
<style lang="sass" rel="stylesheet/scss" scoped>
  .document{
    min-height: 560px;
    width: 100%;
    display: flex;
    .search{
      width: 200px;
      background-color: #fff;
      padding: 14px 20px 20px 20px;
      .search_ul{
        .search_li{
          display: flex;
          align-items: center;
          justify-content: space-between;
          line-height: 40px;
          font-size: 14px;
          color: #333;
          cursor: pointer;
          i{
            width: 12px;
            height: 12px;
            background: url("../../assets/images/client/more.png") no-repeat;
          }
        }
        .search_li:hover, .search_li_active{
          color: #1daef8;
          i{
            background: url("../../assets/images/client/more_active.png") no-repeat;
          }
        }
      }
    }

    .wapper {
      margin-left:20px;
      background-color: #fff;
      width: calc(100% - 220px);
      position: relative;
      padding-bottom: 70px;
      .tabs{
        padding:0 20px 0 20px;
        .tabs-nav {
          height: 60px;
          display: flex;
          align-items: center;
          border-bottom: 2px solid #ddd;
          .tab{
            height: 100%;
            margin-right: 60px;
            font-size: 16px;
            color: #333;
            font-weight: bold;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            flex-shrink: 0;
            position: relative;
            transition: all 0.2s;
            cursor: pointer;
            &.active{
              color: #1daef8;
              &::after{
                content: '';
                width: 100%;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: -2px;
                color: #1daef8;
                border-bottom: 4px solid #1daef8;
              }
              a{
                color: #1daef8;
              }
            }
            a{
              color: #333;
              text-decoration: none;
              height: 100%;
              display: flex;
              align-items: center;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Index.vue?f3283cb6